module.exports = __webpack_public_path__ + "static/media/room-4.1e407d88.jpeg";